export default [{
  path: '/system',
  name: '',
  component: resolve => require(['@/views/home'], resolve),
  children: [
    // {
    //   path: 'userFeel',
    //   name: '用户反馈 ',
    //   meta: {
    //     title: '用户反馈'
    //   },
    //   component: resolve => require(['@/views/system/userFeel/index'], resolve),
    // },
    {
      path: 'userFeelDetail',
      name: '用户反馈详情',
      meta: {
        title: '用户反馈详情'
      },
      component: resolve => require(['@/views/system/userFeelDetail'], resolve),
    },
    {
      path: 'help',
      name: '帮助中心',
      meta: {
        title: '帮助中心'
      },
      component: resolve => require(['@/views/system/help/index'], resolve),
    },
    {
      path: 'userFeel',
      name: '消息中心 ',
      meta: {
        title: '消息中心'
      },
      component: resolve => require(['@/views/system/userFeel/index'], resolve),
    },
    {
      path: 'feedback',
      name: '消息中心',
      meta: {
        title: '消息中心'
      },
      component: resolve => require(['@/views/system/feedback'], resolve),
    },

  ]
  }]



// WEBPACK FOOTER //
// ./src/router/system_routers.js